import React from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getGenders } from '../redux.actions';

const SelectGender = ({ getGenders, input: { value, onChange } }) => {
    const [genders, setGenders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getGenders({
            handleSubmit: (data) => {
                setIsLoading(false);
                if (data && Array.isArray(data)) {
                    setGenders(
                        data.map((gender) => ({
                            name: gender,
                            value: gender
                        }))
                    );
                }
            }
        });
    }, [getGenders]);

    const selectedGender = genders.find((g) => String(g.value) === String(value)) || null;

    return (
        <Autocomplete
            size='small'
            sx={{
                minWidth: 158,
                backgroundColor: theme => theme.palette.common.paper
            }}
            componentsProps={{
                paper: {
                    sx: {
                        '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                        }
                    }
                }
            }}
            options={genders}
            getOptionLabel={(option) => option.name || ''}
            value={selectedGender}
            onChange={(event, newValue) => {
                onChange(newValue ? newValue.value : '');
            }}
            loading={isLoading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Gender'
                    placeholder='Select gender'
                    sx={{
                        '& .MuiInputBase-input': { fontSize: '12px' },
                        '& .MuiInputLabel-root': { fontSize: '12px' }
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        color='inherit'
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};

const mapDispatchToProps = (dispatch) => ({
    getGenders: (payload) => dispatch(getGenders(payload))
});

export default connect(null, mapDispatchToProps)(SelectGender);
